import { isIosStandalonePwa } from "./iosStandaloneScrollLock";

/**
 * Recover from the iOS-standalone keyboard gap.
 *
 * In an installed PWA, iOS pans/shrinks the webview when the software
 * keyboard opens; on dismissal it often fails to restore it, leaving a
 * system-painted white strip at the bottom outside the page.
 */
export function fixStandaloneKeyboardGap(): void {
  if (typeof window === "undefined") return;
  if (!isIosStandalonePwa()) return;

  const snapBack = () => {
    // Let WebKit finish the keyboard-dismiss layout pass before re-anchoring.
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
      });
    });
  };

  // Primary signal: the visual viewport growing back = keyboard dismissed.
  const vv = window.visualViewport;
  if (vv) {
    let lastHeight = vv.height;
    vv.addEventListener("resize", () => {
      const grew = vv.height > lastHeight + 40;
      lastHeight = vv.height;
      if (grew) snapBack();
    });
  }

  // Belt and braces: leaving any editable field (blur fires slightly before
  // the viewport resize on some iOS versions).
  document.addEventListener("focusout", (event) => {
    const target = event.target as HTMLElement | null;
    if (!target) return;
    const tag = target.tagName;
    if (tag === "TEXTAREA" || tag === "INPUT" || target.isContentEditable) {
      window.setTimeout(snapBack, 250);
    }
  });
}
